import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/landing.css';
import { apiIsLoggedIn } from '../api/api';
import TopBarMain from '../components/topbars/TopBarMain';

class LoggedInLanding extends React.Component {
    constructor(props){
        super(props);
    }

    componentDidMount() {
        apiIsLoggedIn().then(isLoggedIn => {
            if (!isLoggedIn) {
                window.location.href = '/';
            }
        });
    }

    render () {
        return (
            <div>
                <TopBarMain />
                <div className='landing'>
                    <h2>Welcome, family!</h2>
                    <div className="landing-links">
                        <h3 className='link-header'><Link to="/contacts">Contact List</Link></h3>
                        <h3 className='link-header'><Link to="/timeline">Reunion Timeline</Link></h3>
                        <h3 className='link-header'><Link to="/tree">Family Tree</Link></h3>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoggedInLanding;
